module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz-circle-e3ab552751deb69c0afcc220df781ce4.png";